import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SnackbarComponent } from './snackbar.component';

/**
 * "Snackbar" is used to show users short-term messages.
 * For example, when an operation is successfully completed or an error message is received,
 * Snackbar provides users with quick feedback. This feedback can help the user to continue
 * the operation or correct an error. Also, since the Snackbar appears at the bottom
 * or top of the screen, it does not interfere with the user's actions
 * and does not distract their attention.
 *
 * ### Installation
 *
 * All public npm packages of TUBITAK is at [https://www.npmjs.com/~tbtk](https://www.npmjs.com/~tbtk).
 * To install Module:
 *
 * ```bash
 * $ npm set registry https://registry.npmjs.org/
 * $ npm install @tbtk/snackbar -s
 * ```
 *
 * Just import it to your project of `@NgModule` import section.
 *
 * ```typescript
 * @NgModule({
 *   declarations: [AppComponent],
 *   imports: [CommonModule, SnackbarModule],
 * })
 * export class AppModule {
 * }
 * ```
 */
@NgModule({
  declarations: [SnackbarComponent],
  imports: [RouterModule, CommonModule],
  exports: [SnackbarComponent],
})
export class SnackbarModule {}
